var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOgretmen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 135,
    viewBox: "0 0 262 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.36789 117.991C3.94332 117.842 2.44378 118.289 1.3941 119.334C-0.480326 121.199 -0.480326 124.183 1.3941 126.048C2.44378 127.092 3.94332 127.54 5.36789 127.391C6.79245 127.54 8.292 127.092 9.34167 126.048C11.2161 124.183 11.2161 121.199 9.34167 119.334C8.21702 118.289 6.79245 117.842 5.36789 117.991Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2876 63.2773C16.3139 63.2773 13.0898 66.4852 13.0898 70.4391C13.0898 74.3931 16.3139 77.6009 20.2876 77.6009C24.2614 77.6009 27.4854 74.3931 27.4854 70.4391C27.4705 66.4852 24.2464 63.2773 20.2876 63.2773Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.674 21.0527C244.425 21.0527 240.092 25.3051 240.092 30.5869C240.092 35.8687 244.365 40.121 249.674 40.121C254.922 40.121 259.256 35.8687 259.256 30.5869C259.256 25.3051 254.997 21.0527 249.674 21.0527Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.269 70.8867C248.923 70.8867 251.068 73.0203 251.068 75.6613C251.068 78.3022 248.923 80.4358 246.269 80.4358C243.615 80.4358 241.471 78.3022 241.471 75.6613C241.471 73.0203 243.615 70.8867 246.269 70.8867Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.201 100.639C259.855 100.639 261.999 102.772 261.999 105.413C261.999 108.054 259.855 110.188 257.201 110.188C254.547 110.188 252.402 108.054 252.402 105.413C252.402 102.772 254.547 100.639 257.201 100.639Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.076 17.7695C130.73 17.7695 132.874 19.9032 132.874 22.5441C132.874 25.185 130.73 27.3186 128.076 27.3186C125.422 27.3186 123.277 25.185 123.277 22.5441C123.292 19.9181 125.437 17.7695 128.076 17.7695Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0896 22.8887C21.7437 22.8887 23.8881 25.0223 23.8881 27.6632C23.8881 30.3041 21.7437 32.4377 19.0896 32.4377C16.4354 32.4377 14.291 30.3041 14.291 27.6632C14.291 25.0223 16.4354 22.8887 19.0896 22.8887Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.65 0C148.304 0 150.449 2.13362 150.449 4.77454C150.449 7.41545 148.304 9.54907 145.65 9.54907C142.996 9.54907 140.852 7.41545 140.852 4.77454C140.867 2.13362 143.011 0 145.65 0Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.75 106.353C120.352 91.612 109.675 84.9874 99.3434 82.1972L85.6676 102.638L81.1239 87.0911L85.0228 80.377H77.825H77.675H70.4922L74.391 87.0911L69.9674 102.474L56.4115 82.1972C46.0647 84.9724 35.3879 91.5971 30.0046 106.353C26.1957 116.798 24.1713 126.526 23.1816 135.001H132.558C131.584 126.511 129.559 116.783 125.75 106.353Z",
    fill: "#3733BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8849 76.8708C93.2403 76.8708 105.731 62.9202 105.731 45.7916C105.731 28.6779 93.2253 14.7422 77.8849 14.7422C62.5146 14.7422 50.0235 28.6779 50.0235 45.7916C50.0085 62.9202 62.5146 76.8708 77.8849 76.8708ZM82.7884 34.6311C88.9516 40.0472 96.1194 44.1653 103.872 46.9852C103.302 62.5621 91.8757 75.0505 77.8849 75.0505C64.599 75.0505 53.6373 63.8304 52.0478 49.3874C63.2344 46.284 74.331 41.5393 82.7884 34.6311Z",
    fill: "#3733BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.656 106.353C237.258 91.6121 226.581 84.9874 216.249 82.1973L195.705 95.7898L173.302 82.1973C162.955 84.9725 152.279 91.5971 146.895 106.353C143.086 116.798 141.062 126.526 140.072 135.001H249.464C248.474 126.511 246.465 116.783 242.656 106.353Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.776 76.8708C210.131 76.8708 222.622 62.9202 222.622 45.7916C222.622 28.6779 210.116 14.7422 194.776 14.7422C179.405 14.7422 166.914 28.6779 166.914 45.7916C166.914 62.9202 179.405 76.8708 194.776 76.8708ZM199.694 34.6311C205.857 40.0472 213.025 44.1653 220.778 46.9852C220.208 62.5621 208.781 75.0505 194.791 75.0505C181.505 75.0505 170.543 63.8304 168.953 49.3874C180.125 46.284 191.222 41.5393 199.694 34.6311Z",
    fill: "#F99E1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_1145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 135,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOgretmen);
export default __webpack_public_path__ + "static/media/ogretmen.6a9c812d76672478d4cd2a916dbdfdb7.svg";
export { ForwardRef as ReactComponent };